import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getEvent, listEventSubscriptions } from "../../firebase/db.js";
import { useAuth } from "../auth/AuthContext.jsx";
import SignIn from "../auth/SignIn.jsx";

export default function EventSubscribers() {
  const { slug } = useParams();
  const { user, loading, configured } = useAuth();
  const [event, setEvent] = useState(null);
  const [subscriptions, setSubscriptions] = useState(null);
  const [forbidden, setForbidden] = useState(false);

  useEffect(() => {
    if (!configured || !user || !slug) return;
    getEvent(slug).then(setEvent).catch(() => setEvent(null));
    listEventSubscriptions(slug)
      .then(setSubscriptions)
      .catch((e) => {
        if (e.message?.includes("403")) setForbidden(true);
        else setSubscriptions([]);
      });
  }, [configured, user, slug]);

  if (loading) return <div className="container" style={{ paddingTop: 80 }}>Loading…</div>;
  if (!user) return <SignIn />;
  if (forbidden) return <div className="container" style={{ paddingTop: 80 }}>You don't have access to this event's subscribers.</div>;

  return (
    <div className="container stack" style={{ paddingTop: 48, paddingBottom: 80, maxWidth: 920 }}>
      <div className="row">
        <div>
          <h1 style={{ margin: 0 }}>Update subscribers</h1>
          <p className="muted" style={{ margin: "8px 0 0" }}>{event?.details?.title || slug}</p>
        </div>
        <div className="spacer" />
        <Link className="btn-ghost btn" to={`/app/edit/${slug}`}>Edit event</Link>
      </div>

      <div className="card stack" style={{ padding: 16 }}>
        <div className="row">
          <strong>Subscribers</strong>
          <div className="spacer" />
          <button
            type="button"
            className="btn-ghost btn mini"
            onClick={() => listEventSubscriptions(slug).then(setSubscriptions).catch(() => setSubscriptions([]))}
          >
            ↻
          </button>
        </div>
        {subscriptions === null && <p className="muted" style={{ margin: 0 }}>Loading subscribers…</p>}
        {subscriptions?.length === 0 && <p className="muted" style={{ margin: 0 }}>No subscribers yet.</p>}
        {!!subscriptions?.length && (
          <div className="stack" style={{ gap: 8 }}>
            {subscriptions.map((sub) => (
              <div key={sub.id} className="subscriber-row">
                <strong>{new Date(sub.createdAt).toLocaleString()}</strong>
                {sub.mobile && <span>{sub.mobile}</span>}
                {sub.email && <span>{sub.email}</span>}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
